const state = {
  visible: false,
  content: {
   
  },
  timeout: 6000,
}

const getters = {
  snackbarVisible: (state) => {
    return state.visible
  },
  snackbarContent: (state) => {
    return state.content
  },
}

const mutations = {
  setSnackbarContent(state, newValue) {
    state.content = newValue
  },
  setSnackbarVisible(state, newValue) {
    state.visible = newValue
  },
}

const actions = {
  showError({ commit }, message) {
    commit('setSnackbarContent', { message, color: 'error', icon: 'mdi-alert-circle' })
    commit('setSnackbarVisible', true)
  },
  showSuccess({ commit }, message) {
    commit('setSnackbarContent', { message, color: 'success', assetIcon: require('@/assets/images/ic-alert-positive@3x.png') })
    commit('setSnackbarVisible', true)
  },
  showDeletionSuccess({ commit }, message) {
    commit('setSnackbarContent', { message, color: '#ff5252', assetIcon: require('@/assets/images/ic-alert-positive@3x.png') })
    commit('setSnackbarVisible', true)
  },
  hideSnackbar({ commit }) {
    commit('setSnackbarVisible', false)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
